import { useQuery } from '@apollo/client/react';
import { useState } from 'react';

import type { Kitchen, Task } from '../libs';
import { LIST_MY_TASKS_QUERY } from '../libs/graphQL';

export type UseMyTasksResult = { tasks: Task[]; loading: boolean; error: boolean; reload: () => void };

type MyTasksData = { listMyTasks: Task[] };

const HOUR_MS = 3_600_000;
const taskWindow = () => {
  const now = Date.now();
  return { from: new Date(now - 4 * HOUR_MS).toISOString(), to: new Date(now + 12 * HOUR_MS).toISOString() };
};

// network-only, and nothing that refetches: Today reads the server when it is opened and when the page is refreshed.
const useMyTasks = (kitchen: Kitchen): UseMyTasksResult => {
  const [initialWindow] = useState(taskWindow);
  const { data, loading, error, refetch } = useQuery<MyTasksData>(LIST_MY_TASKS_QUERY, {
    variables: { kitchen, ...initialWindow },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
  return {
    tasks: data?.listMyTasks ?? [],
    loading,
    error: error !== undefined,
    reload: () => {
      refetch({ kitchen, ...taskWindow() }).catch(() => {});
    }
  };
};

export default useMyTasks;
